<div class="container">
    <!-- Navbar -->
    <nav class="navbar navbar-expand-md navbar-light">
        <a class="navbar-brand mr-4" href="#">
            <img src="assets/logo_green_blue.svg" width="150" alt="Estudei">
        </a>
        <button class="navbar-toggler hidden-sm-up" type="button" (click)="isNavCollapsed = !isNavCollapsed"
            data-target="#navbarEstudei" aria-controls="navbarEstudei" aria-expanded="false" aria-label="Exibir Menu">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div [ngbCollapse]="isNavCollapsed" class="collapse navbar-collapse" id="navbarEstudei">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['']">Início</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['']">Assinaturas</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['']">Quem Somos</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/tutorial']">Tutoriais</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/editais']">Editais</a>
                </li>
            </ul>

            <form class="form-inline">
                <button class="btn btn-info ml-auto" [routerLink]="['']">Assinar agora</button>
            </form>
        </div>
    </nav>
    <!-- /Navbar -->

    <!-- Cabeçalho -->
    <div class="row top-content">
        <div class="col">
            <h1>Para qual prova ou concurso quer estudar?</h1>
            <p class="text-justify">Aqui estão os editais já cadastrados em nossa plataforma. Não encontrou o que
                procurava? Fique tranquilo! Você pode solicitar o edital à nossa equipe (<a
                    href="mailto:contato@estudei.com.br">contato@estudei.com.br</a>) ou criar o seu plano personalizado,
                adicionando suas próprias disciplinas e assuntos.</p>
            <input type="text" name="search-list" id="search-list" class="form-control form-control-lg search-list"
                placeholder="Pesquisar..." #search (input)="SearchAnnouncements(search.value)">
            <small class="form-text text-muted text-right" (click)="collapse.toggle()">Busca Avançada</small>

            <!-- Filtros -->
            <div class="all-filters" #collapse="ngbCollapse" [(ngbCollapse)]="collapseFilter">
                <div class="row mx-0 mt-2" (change)="SearchAnnouncements()">
                    <div class="col">
                        <div class="btn-group btn-group-sm btn-group-toggle btn-block regions">
                            <label class="btn-outline-primary" ngbButtonLabel
                                *ngFor="let region of announcementFilter.regions">
                                <input type="checkbox" ngbButton [(ngModel)]="region.show"
                                    (change)="UpdateFilters('region', region.name, region.show)">
                                {{ region.name }}
                            </label>
                        </div>
                    </div>
                </div>

                <div class="row mx-0 mt-2" (change)="SearchAnnouncements()">
                    <div class="col">
                        <div class="btn-group btn-group-sm btn-group-toggle btn-block states">
                            <label class="btn-outline-primary" ngbButtonLabel
                                *ngFor="let state of announcementFilter.states.slice(0, -1)">
                                <!-- Remover o Último Pois é a Opção do 'FEDERAL' -->
                                <input type="checkbox" ngbButton [(ngModel)]="state.show"> {{ state.name }}
                            </label>
                        </div>
                    </div>
                </div>

                <div class="row mx-0 mt-2" (change)="SearchAnnouncements()">
                    <div class="col">
                        <div class="btn-group btn-group-sm btn-group-toggle btn-block objectives">
                            <label class="btn-outline-primary" ngbButtonLabel
                                *ngFor="let objective of announcementFilter.objectives">
                                <input type="checkbox" ngbButton [(ngModel)]="objective.show">
                                {{ objective.value |enumText:'AnnouncementType' }}
                            </label>
                        </div>
                    </div>
                </div>

                <div class="d-flex flex-row flex-wrap mt-2 justify-content-end" style="padding: 0 15px; gap: 3px 8px">
                    <div class="dropdown-filter">
                        <div ngbDropdown>
                            <button class="btn btn-block btn-sm btn-outline-primary text-right" ngbDropdownToggle
                                (click)="GetAuxFilters('institute')">
                                <span class="dropdown-list-field w-100 pr-4 text-left text-truncate">
                                    {{ displayInstitutes }}</span>
                            </button>
                            <div ngbDropdownMenu class="px-3 pt-1" (change)="SearchAnnouncements()">
                                <div class="dropdown-list-items">
                                    <div class="custom-control custom-checkbox d-flex my-2"
                                        *ngFor="let institute of announcementFilter.institutes; let i = index">
                                        <input class="custom-control-input" type="checkbox" [(ngModel)]="institute.show"
                                            [id]="'i'+i">
                                        <label class="custom-control-label" [for]="'i'+i">
                                            {{ institute.name }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="dropdown-filter">
                        <div ngbDropdown>
                            <button class="btn btn-block btn-sm btn-outline-primary text-right" ngbDropdownToggle
                                (click)="GetAuxFilters('category')">
                                <span class="dropdown-list-field w-100 pr-4 text-left text-truncate">
                                    {{ displayCategories }}</span>
                            </button>
                            <div ngbDropdownMenu class="px-3 pt-1" (change)="SearchAnnouncements()">
                                <div class="dropdown-list-items">
                                    <div class="custom-control custom-checkbox d-flex my-2"
                                        *ngFor="let category of announcementFilter.categories; let c = index">
                                        <input class="custom-control-input" type="checkbox" [(ngModel)]="category.show"
                                            [id]="'c'+c">
                                        <label class="custom-control-label" [for]="'c'+c">
                                            {{ category.name }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col"></div>
                    <div class="col"></div>
                </div>
            </div>
            <!-- /Filtros -->
        </div>
    </div>
    <!-- /Cabeçalho -->

    <!-- Editais -->
    <div class="row mx-0 mt-5" infiniteScroll (scrolled)="onScroll()">
        <div class="card-columns" *ngFor="let section of listAnnouncements">
            <div class="card" *ngFor="let announcement of section">
                <div class="card-body">
                    <div class="row mb-4">
                        <div class="col-auto">
                            <div class="institute-img"
                                [ngStyle]="{'background-image': 'url('+mapInstituteImages.get(announcement.instituteId)+')'}">
                            </div>
                        </div>

                        <div class="col my-auto">
                            <h5>{{ announcement.name }}</h5>
                        </div>
                    </div>

                    <div class="row job-item" *ngFor="let job of announcement.jobs">
                        <div class="col d-flex">
                            {{ job.name }}
                        </div>
                        <div class="col col-auto">
                            <ng-container *ngIf="job.vacancies">
                                <i class="fas fa-users"></i>
                                {{ job.vacancies + ' vagas' }}
                            </ng-container>
                            <ng-container *ngIf="job.wage">
                                <i class="fas fa-money-bill-wave ml-2"></i>
                                {{ 'R$' + (job.wage |mask:'separator.2':'.') }}
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 text-center" *ngIf="listAnnouncements.length&&!listAnnouncements[0].length">
            <p>Não foram encontrados resultados para a busca, tente novamente com novos parâmetros</p>
        </div>
    </div>
    <!-- /Editais -->
</div>